import type { TypeName } from '@tdmons/sim';

/**
 * Types whose color is light enough that white text fails 4.5:1 on it: their chips and move tiles
 * take --text-on-light (ui-style-guide "Color"). Normal joined in slice 8c.
 */
export const LIGHT_TYPES: ReadonlySet<TypeName> = new Set<TypeName>([
  'Normal',
  'Electric',
  'Ice',
  'Ground',
  'Steel',
]);
